"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeamVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class BeamVfxStepArgs {
    constructor(startAt, endAt, type, pathType, delay = 0) {
        this.startAt = startAt;
        this.endAt = endAt;
        this.type = type;
        this.pathType = pathType;
        this.delay = delay;
        this.__typeName = "Beam";
        this.id = (0, uuid_1.v4)();
    }
}
exports.BeamVfxStepArgs = BeamVfxStepArgs;
